import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { IStore } from 'redux/IStore';
import { connect, Dispatch } from 'react-redux';
import { Link } from 'react-router';
import { IShopCard } from 'models/shop/shopcard';
import { CoverPicture, Spinner, Button } from 'components';
import { getOfficeStaff } from 'redux/modules/shop/shopcard';
import { thumbUrl } from 'helpers/common';
import renderIcon from 'helpers/renderIcon';
import { IOfficeMember } from 'models/shop/members';

interface IOwnProps {
	officeId: string;
	shopId: IShopCard['id'];
	t?: any;
	onServicesMemberHandleClick?: (activeMembers: any) => void;
	onClick?: (activeMembers: any) => void;
}

interface IOwnState {
	activeMembers: any[];
	active: boolean;
}

interface IProps extends IOwnProps, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps> {}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ShopCardOfficeStaffComponent extends React.Component<IProps, IOwnState> {
	constructor(props) {
		super(props);

		this.state = {
			activeMembers: [],
			active: false,
		};
	}

	public componentDidMount() {
		this.props.getStaff();
	}

	public componentDidUpdate(prevProps: IProps) {
		if (prevProps.officeId !== this.props.officeId) {
			this.props.getStaff();
		}
	}

	handleClick(member) {
		const selectedMembers = this.state.activeMembers;
		if (!member.length) {
			// If clicking on staff member
			const pos = selectedMembers.map((mem) => mem.id).indexOf(member.id);
			if (pos === -1) {
				// Add clicked member
				selectedMembers.push({ ...member, selected: true });
			} else {
				// Remove clicked member
				selectedMembers.splice(pos, 1);
			}
		} else {
			// If clicking on All members
			if (member.length === selectedMembers.length) {
				// Remove all members
				member.map(() => {
					selectedMembers.pop();
				});
			} else {
				// Add all members
				member.map((m) => {
					if (selectedMembers.map((sm) => sm.id).indexOf(m.id) === -1) {
						selectedMembers.push({ ...m, selected: true });
					}
				});
			}
		}

		this.setState({ activeMembers: selectedMembers });
		this.props.onServicesMemberHandleClick(selectedMembers);

		if (this.props.onClick) {
			this.props.onClick(this.state.activeMembers);
		}
	}

	handleShow() {
		this.setState({ active: !this.state.active });
	}

	public render() {
		const { t, staff, isShopOwner } = this.props;
		const { activeMembers, active } = this.state;
		if (!staff) {
			return <Spinner />;
		}
		if (!staff.length) {
			return (
				<div className="staff-container">
					<div className="row justify-content-center">
						<div className={`staff-no-members col-2`}>
							<img src={require('containers/Html/images/no-team-logo.svg')} />
							<p className="p18">{t('Shop_ShopCard_Services_TeamInCreation')}</p>
							<br />
							{isShopOwner ? (
								<Link to={`/shop/${this.props.shopId}/edit/members`} className="p14 pointer">
									<Button>{t('Shop_Shopcard_Services_EditStaff')}</Button>
								</Link>
							) : null}
						</div>
					</div>
				</div>
			);
		}
		return (
			<div className="staff-container">
				<div className="row justify-content-center">
					{/* All members column */}
					{staff.length > 1 && (
						<div className="col-lg-2 col-md-3 col-4 staff-member">
							<div
								className={`member ${activeMembers?.length === staff.length || !activeMembers.length ? 'active' : ''}`}
								onClick={() => this.handleClick(staff)}
							>
								{activeMembers?.length === staff.length || !activeMembers.length
									? renderIcon('check1', 16, 16, 'check')
									: null}
								<img src={require('containers/Html/icons/members.svg')} className="profile-photo-container all small" />
								<p className="member-name p14">{t('Shop_ShopCard_Services_AllMembers')}</p>
								<p className="member-title p14 muted">{staff.length}</p>
							</div>
						</div>
					)}

					{/* Go through members */}
					{staff.length > 4 && !active
						? staff?.slice(0, 4).map((s, index) => (
								<div key={index} className="col-lg-2 col-md-3 col-4 staff-member">
									<div
										className={`member ${activeMembers.map((actMem) => actMem.id).indexOf(s.id) > -1 ? 'active' : ''}`}
										onClick={() => this.handleClick(s)}
									>
										{activeMembers.map((actMem) => actMem.id).indexOf(s.id) > -1
											? renderIcon('check1', 16, 16, 'check')
											: ''}
										<CoverPicture
											imageUrl={thumbUrl(s.picture, 'small')}
											small={true}
											hasPicture={Boolean(s.picture)}
										/>
										<p className="member-name p14">{s.name?.length > 47 ? s.name.substring(0, 47) + '...' : s.name}</p>
										<p className="member-title p14 muted">
											{s.jobTitle ? (s.jobTitle?.length > 50 ? s.jobTitle.substring(0, 50) + '...' : s.jobTitle) : ''}
										</p>{' '}
										{/*If set prikaži*/}
									</div>
								</div>
						  ))
						: staff?.map((s, index) => (
								<div key={index} className="col-lg-2 col-md-3 col-4 staff-member">
									<div
										className={`member ${activeMembers.map((actMem) => actMem.id).indexOf(s.id) > -1 ? 'active' : ''}`}
										onClick={() => this.handleClick(s)}
									>
										{activeMembers.map((actMem) => actMem.id).indexOf(s.id) > -1
											? renderIcon('check1', 16, 16, 'check')
											: ''}
										<CoverPicture
											imageUrl={thumbUrl(s.picture, 'small')}
											small={true}
											hasPicture={Boolean(s.picture)}
										/>
										<p className="member-name p14">{s.name?.length > 47 ? s.name.substring(0, 47) + '...' : s.name}</p>
										<p className="member-title p14 muted">
											{s.jobTitle ? (s.jobTitle?.length > 47 ? s.jobTitle.substring(0, 47) + '...' : s.jobTitle) : ''}
										</p>{' '}
										{/*If set prikaži*/}
									</div>
								</div>
						  ))}

					{/* Show all column */}
					{staff.length > 4 && (
						<div className={`col-lg-2 col-md-3 col-4 staff-show-all`}>
							<div className="member" onClick={() => this.handleShow()}>
								<p className="member-name p14">
									{active ? t('Shop_ShopCard_Services_ShowLess') : t('Shop_ShopCard_Services_ShowAll')}
								</p>
							</div>
						</div>
					)}
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state: IStore, ownProps: IOwnProps) => {
	const office = (state.shopcard.shopcard?.offices || []).find((o) => o.id === ownProps.officeId);
	const staff: IOfficeMember[] = (office.staff as IOfficeMember[]) || [];
	return {
		office,
		staff,
		isShopOwner: state.shopcard.isMyShop,
	};
};

const mapDispatchToProps = (dispatch: Dispatch<IStore>, ownProps: IOwnProps) => ({
	getStaff: () => dispatch(getOfficeStaff(ownProps.officeId)),
});

const ShopCardOfficeStaff = connect(mapStateToProps, mapDispatchToProps)(ShopCardOfficeStaffComponent);

export { ShopCardOfficeStaff };
